<mat-form-field [attr.data-form-field]="field" [appearance]="appearance" [formGroup]="formGroup" class="full-width" [class.hide-hint-space]="!hint">
  @if (label) {
    <mat-label class="label">{{ label | translate }}</mat-label>
  }
  <mat-slide-toggle
    color="primary"
    (change)="toggleChanged($event)"
    [checked]="formGroup.controls[field].value === true"
    [labelPosition]="labelPosition"
    [class.float-right]="floatRight"
    >
    <ng-content></ng-content>
  </mat-slide-toggle>
  <input class="hide" matInput [formControlName]="field" [placeholder]="label | translate" />

  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
